import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { CLUB_ELO_ENABLED } from "@/lib/rolloutGates";
import type { ClubHostReviewTask } from "@/lib/clubHostReview";

export function useClubHostReview(enabled = true) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["match_host_club_tasks", user?.id],
    enabled: CLUB_ELO_ENABLED && enabled && !!user,
    retry: false,
    staleTime: 30_000,
    refetchInterval: 60_000,
    queryFn: async (): Promise<ClubHostReviewTask[]> => {
      const { data, error } = await (supabase as any).rpc("get_my_match_host_club_tasks");
      if (error) throw error;
      return data ?? [];
    },
  });
}
